<template>
  <Head title="Iniciar sesión" />
  <div class="flex items-center justify-center p-6 min-h-screen bg-blue-900">
    <div class="w-full max-w-md">
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-12">
           <img
      :src="$page.props.tenant.logo"
      alt="Logo"
      class="h-20 object-contain"
    />
          <!-- <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />              -->
          <div class="mt-6 mx-auto w-40 border-b-2" />
          <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Correo electrónico" type="email" autofocus autocapitalize="off" />
          <text-input v-model="form.password" :error="form.errors.password" class="mt-6" label="Contraseña" type="password" />
          <label class="flex items-center mt-6 select-none" for="remember">
            <input id="remember" v-model="form.remember" class="mr-1" type="checkbox" />
            <span class="text-sm">Recordarme</span>
          </label>
        </div>
        <div class="flex px-10 py-4 bg-gray-100 border-t border-gray-100">
          <Link class="text-sm text-blue-600 hover:text-blue-700 pt-2" href="/forgot-password">Olvidaste tu contraseña?</Link>
          <loading-button :loading="form.processing" class="btn-primary ml-auto" type="submit">Entrar</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Logo from '@/Shared/Logo.vue'
import TextInput from '@/Shared/TextInput.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'

export default {
  components: {
    Head,
    LoadingButton,
    Logo,
    TextInput,
    Link,
  },
  props: { auth: Object, },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/login')
    },
  },
}
</script>
